import React, { Suspense, useLayoutEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import './DashboardLayout.scss';
import { Outlet, useLocation } from 'react-router-dom';
import CommonService from '../../api-services/CommonService';

const DashboardLayout = () => {
  // Note - Wrape the layout component as a parent component
  // on the top of any child component for which we have to show Sidebar.

  const location = useLocation();

  // Audit log the page request
  useLayoutEffect(() => {
    const commonService = new CommonService();
    commonService.auditLog(location.pathname);
  }, [location]);

  return (
    <div className="main">
      <Header />
      <div className="main-container">
        <Suspense fallback="Loading...">
          <Outlet />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
};

export default DashboardLayout;
